<!-- @format -->

<ng-container *transloco="let t">
  <div class="modal-header">
    <h2 class="modal-title" sisAutofocus>
      @if (event.extendedProps.eventName) {
        <ng-container>{{ event.extendedProps.eventName | localizedString }}<br /></ng-container>
      }
      @if (!event.extendedProps.eventName && event.extendedProps.courseUnitRealisation) {
        <ng-container>{{ event.extendedProps.courseUnitRealisation | courseUnitRealisationName: true }}<br /></ng-container>
      }
      @if (!event.extendedProps.courseUnitRealisation) {
        <ng-container>{{ event.extendedProps.name | localizedString }}<br /></ng-container>
      }
      <ng-container
        >{{ event.extendedProps.eventTitle?.name | localizedString }},
        {{ event.extendedProps.studySubGroupName | localizedString }}</ng-container
      >
    </h2>
    <sis-modal-close-button />
  </div>
  <div class="modal-body">
    @if (event.extendedProps.cancelled) {
      <sis-tiny-badge [variant]="'danger'">{{ t("SIS_COMPONENTS.CALENDAR.EVENT_CANCELLED") }}</sis-tiny-badge>
    }
    @if (event.extendedProps.enrolment.state === "NOT_ENROLLED") {
      <sis-tiny-badge [variant]="'accent'">{{ t("SIS_COMPONENTS.CALENDAR.NOT_ENROLLED") }}</sis-tiny-badge>
    }
    <sis-description-list-compact [columnCount]="1">
      <dl>
        <ng-template #compactListItem>
          <dt class="label colon">{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.EVENTS_TABLE.COLUMNS.TIME") }}</dt>
          <dd class="value">
            {{ event.start | weekdayAndDateTimeRange: event.end }}
          </dd>
        </ng-template>
        <ng-template #compactListItem>
          <dt class="label colon">{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.EVENTS_TABLE.COLUMNS.LOCATIONS") }}</dt>
          @for (locationId of event.extendedProps.locationIds; track locationId) {
            @if (locationId | location | async; as location) {
              <dd class="value">
                {{ location.name | localizedString }}
              </dd>
            }
          }
          @if (event.extendedProps.locationIds?.length === 0 && !event?.extendedProps.locationsRemoved) {
            <dd class="value">
              {{ t("SIS_COMPONENTS.CALENDAR.NO_LOCATION") }}
            </dd>
          }
          @if (event.extendedProps.locationsRemoved) {
            <dd class="value">
              {{ t("SIS_COMPONENTS.CALENDAR.LOCATIONS_REMOVED") }}
            </dd>
          }
        </ng-template>
        <ng-template #compactListItem>
          <dt class="label colon">{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.EVENTS_TABLE.COLUMNS.TEACHERS") }}</dt>
          @for (teacherId of event.extendedProps.teacherIds; track teacherId; let last = $last) {
            <dd class="value"> {{ teacherId | publicPerson | async | personFullName }}{{ last ? "" : "," }} </dd>
          }
          @if (!event.extendedProps.teacherIds || event.extendedProps.teacherIds.length === 0) {
            <dd class="value">
              {{ t("SIS_COMPONENTS.CALENDAR.NO_TEACHER") }}
            </dd>
          }
        </ng-template>
        @if (event.extendedProps.notice) {
          <ng-template #compactListItem>
            <dt class="label colon">{{ t("FIELD_NAMES.notice") }}</dt>
            <dd class="value">{{ event.extendedProps.notice | localizedString }}</dd>
          </ng-template>
        }
      </dl>
    </sis-description-list-compact>
    <sis-button (clicked)="openCourseUnitInfoModal()" [link]="true">
      {{ t("OPEN_COURSE_UNIT_INFO") }}
    </sis-button>
  </div>
  <div class="modal-footer confirm-dialog-footer">
    <sis-button (clicked)="activeModal.dismiss()">{{ t("BUTTON.CLOSE") }}</sis-button>
  </div>
</ng-container>
